import { equals } from 'ramda'
import React,
{ Component } from 'react'
import { connect } from 'react-redux'

import { Button } from '@driftt/dds'
import {
  Footer,
  Sidebar,
  TextLoader
} from '@driftt/tide-core'
import {
  getBulkSegments,
  getContact,
  getSegmentMemberships
} from 'api/contacts'
import ContactSidebarDetails from 'components/Contacts/ContactSidebar/ContactSidebarDetails'
import { delay } from 'utils'

import './style.css'

const mapStateToProps = state => ({
  orgId: state.user.orgId,
  connectedIntegrations: state.integrations.status,
})


class ContactSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      contact: null,
      id: props.id
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!equals(prevProps.id, this.props.id)) {
      this.getContact()
    }
  }

  componentDidMount() {
    delay(this.getContact, 1000)
  }

  getContactSubscriptions = async () => {
    const {
      id,
      orgId
    } = this.props

    try {
      const { data: memberships } = await getSegmentMemberships(id, orgId)

      const { data: segments } = await getBulkSegments(memberships, orgId)

      this.setState({ contactSubscribedSegments: segments })
    } catch(e) {
      console.log(e)
    }
  }

  getContact = async () => {
    const { id } = this.props

    try {
      const { data } = await getContact(id)

      this.setState({ contact: data }, this.getContactSubscriptions)
    } catch(e) {
      console.log(e)
    }
  }

  render() {
    const {
      open,
      close,
      id,
      connectedIntegrations,
      orgId,
      history
    } = this.props
    const {
      contact,
      contactSubscribedSegments
    } = this.state

    return (
      <Sidebar
        isOpen={open}
        showClose={true}
        hideOverlay={true}
        title="Preview contact"
        className="contacts-contact-sidebar"
        close={close}
      >
        {!contact &&
          <TextLoader text="Grabbing your contact information" className="contacts-contact-sidebar--loading"/>
        }
        {!!contact &&
          <ContactSidebarDetails contact={contact} segments={contactSubscribedSegments}
            connectedIntegrations={connectedIntegrations} orgId={orgId}/>
        }
        <Footer className="contacts-contact-sidebar--footer">
          <Button
            onClick={() => history.push(`/details/${id}`)}
            className="contacts-contact-sidebar--footer-button"
          >
            View full details
          </Button>
        </Footer>
      </Sidebar>
    )
  }
}

export default connect(mapStateToProps, null)(ContactSidebar)
